export interface NameParts {
  given: string;
  family: string;
}

export function splitName(name?: string): NameParts | undefined {
  if (name === undefined) {
    return undefined;
  }

  const [given, ...familyNameParts]: string[] = splitNameIntoArray(name);

  return {
    given: given.trim(),
    family: compactWhitespaceAndJoin(familyNameParts),
  };
}

function splitNameIntoArray(name: string): string[] {
  // First, try to split by comma.
  const commaNames = name.split(',');
  if (commaNames.length > 1) {
    return commaNames;
  }

  // Otherwise, split by whitespace.
  return name.split(/\s/);
}

function compactWhitespaceAndJoin(nameParts: string[]): string {
  return nameParts
    .map((p) => p.trim())
    .filter((p) => p) // Get rid of empty strings
    .join(' ');
}
